export default {
  title: 'Encomendas perdidas',
  card_title: 'E-mails de encomendas perdidas',
  intro:
    'Se ninguém aceitar uma encomenda no prazo de {{minutes}} minutos, esta é rejeitada automaticamente. Todos os que estão nesta lista recebem então um e-mail com a encomenda, para que alguém possa dar seguimento.',
  default: {
    owner: 'Proprietário do restaurante',
    partner: 'Parceiro',
    owner_missing: 'O proprietário do restaurante ({{email}}) não receberá estes e-mails.',
    partner_missing: 'O endereço predefinido do parceiro ({{email}}) não receberá estes e-mails.',
  },
  empty: 'Ninguém seria informado sobre encomendas perdidas. Adicione pelo menos um e-mail para guardar.',
  save_error: 'Não foi possível guardar os e-mails. Verifique a sua ligação e tente novamente.',
  load_error: 'Não foi possível carregar os e-mails. Verifique a sua ligação e tente novamente.',
  unavailable: 'Os e-mails de encomendas perdidas não estão disponíveis para este restaurante.',
  buttons: {
    save: 'Guardar',
    retry: 'Tentar novamente',
  },
  toasts: {
    saved: 'E-mails de encomendas perdidas guardados',
  },
};
